import type { FC } from 'react';

import type { Amount } from '@shared/core-types';
import { LocalizedAmount } from '@shared/core-ui-amount';

import type { CommonItemProps } from './types';
import { ProductsListItemWrapper } from '../ProductsListItemWrapper';

type Props = CommonItemProps & {
    amount: Amount;
    colorize?: boolean;
    bold?: boolean;
    superscript?: boolean;
};

export const ProductsListAmountItem: FC<Props> = ({
    'data-cy': dataCy,
    className,
    label,
    labelClassName,
    labelColumnWidth,
    amount,
    colorize = true,
    bold = false,
    superscript = false,
}) => {
    const supScript = superscript
        ? LocalizedAmount.SUPERSCRIPT.FORCED
        : LocalizedAmount.SUPERSCRIPT.AUTO;

    return (
        <ProductsListItemWrapper
            data-cy={dataCy}
            className={className}
            label={label}
            labelClassName={labelClassName}
            labelColumnWidth={labelColumnWidth}
        >
            <LocalizedAmount
                amount={amount}
                coloured={colorize}
                data-cy={dataCy}
                inheritFontWeight={!bold}
                superscript={supScript}
                showCurrency
            />
        </ProductsListItemWrapper>
    );
};
